export default {
  getHead: () => {
    return [{name: '현장(공사)명'}, {name: '종류'}, {name: '현장주소'}, {name: '공사기간'}, {name: '발주자'}, {name: '설계자'}, {name: '작성부서'}, {name: '작성자'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).businessInfo.field_name // 현장명
      case 1: return func.getContent(value).inputB_4 // 종류
      case 2: return func.getContent(value).inputB_6 // 현장주소
      case 3: return `${func.getContent(value).inputB_7}~${func.getContent(value).inputB_8}` // 공사기간
      case 4: return func.getContent(value).inputC_5 // 발주자
      case 5: return func.getContent(value).inputD_5 // 설계자
      case 6: return func.getContent(value).stdInfo.section ? func.getContent(value).stdInfo.section : func.getContent(value).stdInfo.com_name // 작성부서
      case 7: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
    case '현장(공사)명': returnData.push('content$body.businessInfo.field_name*%[:default_skw]%'); break
    case '종류': returnData.push('content$body.inputB_4*%[:default_skw]%'); break
    case '현장주소': returnData.push('content$body.inputB_6*%[:default_skw]%'); break
    case '발주자': returnData.push('content$body.inputC_5*%[:default_skw]%'); break
    case '설계자': returnData.push('content$body.inputD_5*%[:default_skw]%'); break
    case '작성부서': returnData.push('content$body.stdInfo.com_name*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
